import {onBeforeUnmount} from '@vue/composition-api'

export default function useEventListener (target, type, handler) {
  target.addEventListener(type, handler)
  onBeforeUnmount(() => {
    target.removeEventListener(type, handler)
  })
}
